<template>
  <div class="box__wrap box__comenzi box_overflow">
    <table>
      <thead>
        <tr>
          <td style="min-width: 22.5rem">Căutare</td>
          <td style="width: 12.5rem">Data</td>
          <td style="width: 12.5rem">Doar compuse</td>
          <td style="width: 12.5rem">Livrare</td>
          <td style="width: 12.5rem">Stoc</td>
          <td style="width: 14rem">Plată</td>
          <td style="width: 14rem">ID Curier</td>
          <td style="width: 12.5rem">Stare</td>
          <td style="width: 12.5rem">Include</td>
          <!-- <td style="width: 10rem;">UE/Non UE</td> -->
          <td style="width: 10rem">Factura</td>
          <td style="width: 10rem">Rezultate pe pagina</td>
          <td style="width: 10rem" class="td_filter_d"></td>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>
            <input
              type="text"
              id="id_comanda"
              :class="
                filter.OrderId != 0
                  ? 'product__input border-info'
                  : 'product__input'
              "
              placeholder="ID comandă"
              v-model="filter.OrderId"
            />

            <input
              type="text"
              id="factura"
              placeholder="Număr factură"
              :class="
                filter.InvoiceNumber != 0
                  ? 'product__input border-info'
                  : 'product__input'
              "
              v-model="filter.InvoiceNumber"
            />

            <input
              type="text"
              id="cautare"
              placeholder="Telefon, nume, e-mail, AWB ..."
              :class="
                filter.Term != 0
                  ? 'product__input border-info'
                  : 'product__input'
              "
              v-model="filter.Term"
            />
          </td>
          <!-- ./ CAUTARE -->
          <td>
            <input
              type="date"
              id="data-min"
              placeholder="min"
              :class="
                filter.MinDate != '2020-10-10'
                  ? 'product__input border-info'
                  : 'product__input'
              "
              v-model="filter.MinDate"
            />
            <input
              type="date"
              id="data-max"
              placeholder="max"
              :class="
                filter.MaxDate != ''
                  ? 'product__input border-info'
                  : 'product__input'
              "
              v-model="filter.MaxDate"
            />
          </td>
          <!-- ./ DATA -->
          <td>
            <input type="checkbox"
              name="metoda_livrare"
              id="metoda_livrare"
              :class="
                filter.OnlyComplex != null
                  ? 'product__input border-info'
                  : 'product__input'
              "
              v-model="filter.OnlyComplex"
            />
             
          </td>
          <td>
            <select
              name="metoda_livrare"
              id="metoda_livrare"
              :class="
                filter.ShippingMethod != 0
                  ? 'product__input border-info'
                  : 'product__input'
              "
              v-model="filter.ShippingMethod"
            >
              <option value="0">Oricare</option>
              <option
                v-for="item in shippingMethods"
                :key="item.id"
                :value="item.id"
              >
                {{ item.name }}
              </option>
            </select>
          </td>
          <!-- ./ METODA LIVRARE -->
          <td>
            <select
              name="rezultate"
              id="rezultate"
              :class="
                filter.stock != ''
                  ? 'product__input border-info'
                  : 'product__input'
              "
              v-model="filter.stock"
            >
              <option value="0">Oricare</option>
              <option value="1">In stoc</option>
              <option value="2">Fara stoc</option>
            </select>
          </td>
          <!-- ./ STOC -->
          <td>
            <select
              v-model="filter.PaymentMethod"
              name="metoda_plata"
              id="metoda_plata"
              :class="
                filter.PaymentMethod != 0
                  ? 'product__input border-info'
                  : 'product__input'
              "
            >
              <option value="0">Oricare</option>
              <option
                v-for="item in paymentMetyhods"
                :key="item.id"
                :value="item.id"
              >
                {{ item.name }}
              </option>
            </select>
          </td>
          <!-- ./ METODA PLATA -->
          <td>
            <select
              v-model="filter.CourierId"
              name="id_curier"
              id="id_curier"
              :class="
                filter.CourierId != 0
                  ? 'product__input border-info'
                  : 'product__input'
              "
            >
              <option value="0">Oricare</option>
              <option v-for="item in couriers" :key="item.id" :value="item.id">
                {{ item.name }}
              </option>
            </select>
          </td>
          <!-- ./ ID_CURIER -->
          <td>
            <select
              v-model="filter.OrderStatusId"
              name="stare"
              id="stare"
              :class="
                filter.OrderStatusId != 0
                  ? 'product__input border-info'
                  : 'product__input'
              "
            >
              <option value="0">Oricare</option>
              <option
                v-for="item in orderStatuses"
                :key="item.id"
                :value="item.id"
              >
                {{ item.name }}
              </option>
            </select>
          </td>
          <!-- ./ STARE -->
          <td>
            <select
              name="include"
              id="include"
              :class="
                filter.Bucuresti != 0
                  ? 'product__input border-info'
                  : 'product__input'
              "
              v-model="filter.Bucuresti"
            >
              <option value="0">Oricare</option>
              <option value="1">Fara Bucuresti</option>
              <option value="2">Doar Bucuresti</option>
              <!-- <option value="3">Doar orase mari</option> -->
            </select>
          </td>
          <!-- ./ INCLUDE -->
          <!-- <td>
	            <select
	              name="ue-nonue"
	              id="ue-nonue"
	              :class="filter.UE != 0 ? 'product__input border-info' : 'product__input'"
	              v-model="filter.UE"
	            >
	              <option value="0">Oricare</option>
	              <option value="1">UE</option>
	              <option value="2">Non-UE</option>
	            </select>
	          </td> -->
          <!-- ./ UE/NONUE -->
          <td>
            <select
              name="factura2"
              id="factura2"
              :class="
                filter.Invoice != 0
                  ? 'product__input border-info'
                  : 'product__input'
              "
              v-model="filter.Invoice"
            >
              <option value="0">Oricare</option>
              <option value="1">Cu factura</option>
              <option value="2">Fara factura</option>
            </select>
          </td>
          <!-- ./ FACTURA -->
          <td>
            <select
              name="rezultate"
              id="rezultate"
              :class="
                filter.Limit != 25
                  ? 'product__input border-info'
                  : 'product__input'
              "
              v-model="filter.Limit"
            >
              <option value="25">25</option>
              <option value="50">50</option>
              <option value="100">100</option>
              <option value="150">150</option>
              <option value="500">500</option>
            </select>
          </td>
          <!-- ./ REZULTATE PE PAGINA -->
          <td class="td_filter_d">
            <a @click="filterSubmit" class="btn btn--light btn--outline ">Filtreaza</a>
          </td>
          <!-- ./ FILTREAZA -->
        </tr>
      </tbody>
    </table>
    <div>
      <a @click="filterSubmit" class="btn btn--light btn--outline filter_btn_m">Filtreaza</a>
    </div>


    <span
      @click="showMoreFilters = !showMoreFilters"
      style="
        font-size: 12px;
        font-weight: bold;
        cursor: pointer;
        display: inline-block;
        margin: 10px 0;
      "
      >{{ showMoreFilters ? "[-]" : "[+]" }} Arată mai multe filtre</span
    >

    <table v-show="showMoreFilters">
      <thead>
        <tr>
          <td>Nr.carti</td>
          <td>Nr. Produse</td>
          <td colspan="2" style="width: 15rem">
            Comenzile trebuie sa contina produsele:
          </td>
          <td colspan="3">Comenzile NU trebuie să conțină produsele</td>
          <td>Grupuri</td>
          <td>Alte filtre</td>
          <td colspan="5">Statistică selecție (top 10 produse)</td>
        </tr>
      </thead>

      <tbody v-show="showMoreFilters">
        <tr>
          <td>
            <input
              type="number"
              id="nr_carti"
              :class="
                filter.BooksNo != 0
                  ? 'product__input border-info'
                  : 'product__input'
              "
              v-model="filter.BooksNo"
            />
          </td>
          <!-- ./ NR_CARTI -->
          <td>
            <input
              type="number"
              id="nr_produse"
              :class="
                filter.ProductNo != null
                  ? 'product__input border-info'
                  : 'product__input'
              "
              v-model="filter.ProductNo"
            />
          </td>
          <!-- ./ NR_PRODUSE -->
          <td colspan="2">
            <autocomplete
              :url="baseAdminUrl + 'product/search'"
              anchor="title"
              label="writer"
              :on-select="getDataToContain"
              :onShouldRenderChild="renderChild"
              name="term"
              id="autocomplete-v"
              :debounce="500"
              style="float: left; width: 100%; z-index: 99999"
              ref="ToContainAutocomplete"
            >
            </autocomplete>
            <ul>
              <li v-for="(item, index) in filter.ToContain" :key="item">
                {{ item }} - <a @click="removeItemToContain(index)"> Sterge</a>
              </li>
            </ul>
          </td>
          <!-- ./ CONTINA PRODUSELE-->
          <td colspan="3">
            <autocomplete
              :url="baseAdminUrl + 'product/search'"
              anchor="title"
              label="writer"
              :on-select="getDataToNotContain"
              :onShouldRenderChild="renderChild"
              name="term"
              id="autocomplete-v"
              :debounce="500"
              style="float: left; width: 100%; z-index: 99999"
              ref="ToNotContainAutocomplete"
            >
            </autocomplete>
            <ul>
              <li v-for="(item, index) in filter.ToNotContain" :key="item">
                {{ item }} -
                <a @click="removeItemToNotContain(index)"> Sterge</a>
              </li>
            </ul>
          </td>
          <!-- ./ SA NU CONTINA PRODUSELE-->
          <td>
            <input
              type="text"
              id="grup-produs"
              placeholder="Grup produs"
              :class="
                filter.GroupProductId != null
                  ? 'product__input border-info'
                  : 'product__input'
              "
              v-model="filter.GroupProductId"
            />
            <br />
            <input
              type="text"
              id="grup-cantitati"
              placeholder="Grup cantitati"
              :class="
                filter.GroupQuantities != null
                  ? 'product__input border-info'
                  : 'product__input'
              "
              v-model="filter.GroupQuantities"
            />
            <br />
            <input
              type="text"
              id="grup-litere"
              placeholder="Grup litere"
              :class="
                filter.groupLetters != null
                  ? 'product__input border-info'
                  : 'product__input'
              "
              v-model="filter.groupLetters"
            />
            <br />
            <input
              type="text"
              id="grup-zone"
              placeholder="Grup zone"
              :class="
                filter.groupAreas != null
                  ? 'product__input border-info'
                  : 'product__input'
              "
              v-model="filter.groupAreas"
            />
          </td>
          <!-- ./ GRUP CANTITATI-->
          <td>
            <label>
              <input type="checkbox" v-model="filter.isEmag" /> Emag Marketplace
            </label>
            <label>
              <input type="checkbox" v-model="filter.isAltex" /> Altex Marketplace
            </label>
            <label>
              <input type="checkbox" v-model="filter.isTrendyol" /> Trendyol Marketplace
            </label>
            <label>
              <input type="checkbox" v-model="filter.isComplaint" /> Reclamație
            </label>
            <label>
              <input type="checkbox" v-model="filter.hasSignature" /> Cu semnătură
            </label>
            <label>
              <input type="checkbox" v-model="filter.withoutSignature" /> Fără semnătură
            </label>
            <label>
              <input type="checkbox" v-model="filter.UnreturnedPayU" /> Nerambursate PayU
            </label>
            <label>
              <input type="checkbox" v-model="filter.WOPreorder" /> Fara produse precomanda
            </label>
            <label>
              <input type="checkbox" v-model="filter.isSimpleOrder" /> Comenzi simple
            </label>
            <label>
              <input type="text" class="product__input" v-model="filter.MinPrice" /> Total minim
            </label>
          </td>
          <td colspan="4">
            <a @click="exportSubmit" class="btn btn--light btn--outline" style="margin-bottom:15px;">Exporta rezultatele</a>
            <br />
            <a @click="calcStatistics" class="btn btn--light btn--outline">Arată statistica</a>
            <div style="padding: 20px; max-height: 200px; overflow-y: scroll">
              <table v-if="statisticsResult.length > 0">
                <tr>
                  <td>Cantitate</td>
                  <td>Produs</td>
                </tr>
                <tr
                  v-for="item in statisticsResult"
                  :key="'sales_' + item.quantity"
                >
                  <td>{{ item.quantity }}</td>
                  <td>{{ item.title }}, {{ item.price }}</td>
                </tr>
              </table>
            </div>
          </td>
          <!-- ./ STATISTICA SELECTIE-->
        </tr>
      </tbody>
    </table>
  </div>
  <!-- --/--  .box__comenzi  -->
</template>
<script>
import { mapGetters } from "vuex";
import orderlist from "@/components/Orders/OrderList.vue";
import orderfilter from "@/components/Orders/OrderFilter.vue";
import axios from "axios";
import Paginate from "vuejs-paginate";
import Autocomplete from "vue2-autocomplete-js";
import moment from "moment";

export default {
  props: [],
  components: {
    Autocomplete,
  },
  data() {
    return {
      paymentMetyhods: [],
      orderStatuses: [],
      couriers: [],
      shippingMethods: [
        { id: 1, name: "Curier" },
        { id: 3, name: "DHL" },
        { id: 6, name: "Easybox" },
      ],
      filter: {
        MinPrice: null,
        ToContain: [],
        ToNotContain: [],
        OrderId: "",
        InvoiceNumber: "",
        BorderouNumber: "",
        Term: "",
        MinDate: "2020-10-10",
        MaxDate: "",
        ShippingMethod: 0,
        PaymentMethod: 0,
        CourierId: 0,
        OrderStatusId: 0,
        UE: 0,
        Page: 1,
        Limit: 50,
        Bucuresti: 0,
        Invoice: 0,
        BooksNo: 0,
        stock: 0,
        UnreturnedPayU: 0,
        WOPreorder: 0,
        isSimpleOrder: false
      },
      statisticsResult: {},
      showMoreFilters: false,
    };
  },
  mounted() {
    var startdate = moment();
    this.filter.MaxDate = startdate.format("YYYY-MM-DD");
    startdate = startdate.subtract(30, "days");
    this.filter.MinDate = startdate.format("YYYY-MM-DD");

    if (this.getParameterByName("grup_id_produse"))
      this.filter.GroupProductId = this.getParameterByName("grup_id_produse");
    if (this.getParameterByName("grup_cantitati"))
      this.filter.GroupQuantities = this.getParameterByName("grup_cantitati");
    if (this.getParameterByName("id_stare"))
      this.filter.OrderStatusId = this.getParameterByName("id_stare");
    if (this.getParameterByName("id_curier"))
      this.filter.CourierId = this.getParameterByName("id_curier");
    if (this.getParameterByName("grup_zone"))
      this.filter.groupAreas = this.getParameterByName("grup_zone");
    if (this.getParameterByName("stoc"))
      this.filter.stock = this.getParameterByName("stoc");
    if (this.getParameterByName("comenzi_compuse"))
      this.filter.OnlyComplex = this.getParameterByName("comenzi_compuse") == "1" ? true : false;

    this.getPaymentMetyhods();
    this.getOrderStatuses();
    this.getCouriers();
  },
  methods: {
    setFilter(filter){
      this.filter = filter;
    },
    calcStatistics() {
      let self = this;
      axios
        .post(this.baseAdminUrl + "order/showstatistics", this.filter)
        .then(function (response) {
          self.statisticsResult = response.data;
        });
    },
    renderChild(data) {
      return `${data.productId},${data.title},${data.price} Lei`;
    },
    exportSubmit() {
      axios.post(this.baseAdminUrl + 'order/export-orders', this.filter, { responseType: 'blob' })
          .then(function (response) {
            const blob = new Blob([response.data], { type: 'application/octet-stream' })
            const link = document.createElement('a')
            link.href = URL.createObjectURL(blob)
            link.download = 'Export Comenzi.csv'
            link.click()
            URL.revokeObjectURL(link.href)
      });
    },
    filterSubmit() {
      this.$emit("filterSubmit", this.filter);
    },
    getDataToContain(data) {
      this.filter.ToContain.push(data.productId);
      this.$refs.ToContainAutocomplete.clearInput();
    },
    removeItemToContain(index) {
      this.filter.ToContain.splice(index, 1);
    },
    getDataToNotContain(data) {
      this.filter.ToNotContain.push(data.productId);
      this.$refs.ToNotContainAutocomplete.clearInput();
    },
    removeItemToNotContain(index) {
      this.filter.ToNotContain.splice(index, 1);
    },
    getPaymentMetyhods() {
      let self = this;
      axios.get(this.baseAdminUrl + "paymentmethods").then(function (response) {
        self.paymentMetyhods = response.data;
      });
    },
    getOrderStatuses() {
      let self = this;
      axios.get(this.baseAdminUrl + "ordertatuses").then(function (response) {
        self.orderStatuses = response.data.filter((e) => {
          return (e.id < 9 || e.id == 16 || e.id == 17 || e.id == 18 || e.id == 22 || e.id == 20 || e.id == 23);
        });
      });
    },
    getCouriers() {
      let self = this;
      axios.get(this.baseAdminUrl + "couriers").then(function (response) {
        self.couriers = response.data;
      });
    },
    getParameterByName(name, url) {
      if (!url) url = window.location.href;
      name = name.replace(/[[\]]/g, "\\$&");
      var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
      if (!results) return null;
      if (!results[2]) return "";
      return decodeURIComponent(results[2].replace(/\+/g, " "));
    },
  },
};
</script>
<style scoped>
.box__comenzi {
  margin-top: 1rem;
}
td {
  text-align: center;
  padding: 10px;
}
td input {
  width: 100% !important;
}
td {
  text-align: center;
  padding: 10px !important;
  min-width: 90px;
}
.product__input {
  width: 100%;
}
.box_overflow {
  overflow-x:auto;
}
.filter_btn_m {
  display: none;
}
@media screen and (max-width: 900px) {
  .td_filter_d {
    display: none;
  }

  .filter_btn_m {
    display: block;
    width: 200px;
    margin-top: 10px;
  }
}
</style>